import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/useUserServicePostHook";

const CreateUserComponent = loadable(
  () => import("../../components/Auth/CreateUser")
);
const CreateUser = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["users"],
    navigateURL: "/users",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.USER}`;
    let formData = {
      ...values,
      "mobile_number": `+977${values?.mobile_number}`,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Create User</span>
      </div>
      <CreateUserComponent
        isLoading={isPostLoading}
        handleCreate={handleCreate}
      />
    </>
  );
};


export default CreateUser